import { createFileRoute } from '@tanstack/react-router'

import { SecretsSettingsPage } from '#features/settings/secrets/secrets-settings-page'

export const Route = createFileRoute('/_app/$workspace/settings/secrets')({
  head: () => ({
    meta: [
      {
        title: 'Manage secrets',
      },
    ],
  }),
  component: () => <SecretsSettingsPage />,
})
